import React from 'react';
import StatsBar from '../../components/StatsBar';
import CTABanner from '../../components/CTABanner';
import HomeHero from './HomeHero';
import HomeAbout from './HomeAbout';
import HomeCategories from './HomeCategories';
import HomeFeaturedProducts from './HomeFeaturedProducts';
import HomeBanner from './HomeBanner';
import HomeValues from './HomeValues';
import HomeBlog from './HomeBlog';
import HomeNewsletter from './HomeNewsletter';
import { useSEO } from '../../hooks/useSEO';

const Home: React.FC = () => {
  useSEO({
    canonical: '/',
    description: 'Manlab Medicals - Premier supplier of hospital, laboratory, and electrosurgical equipment in Zimbabwe. CE/FDA certified products delivered across Africa.'
  });

  return (
    <main>
      <HomeHero />
      <StatsBar />
      <HomeAbout />
      <HomeValues />
      <HomeCategories />
      <HomeFeaturedProducts />
      <HomeBanner />
      <HomeBlog />
      <HomeNewsletter />
      <CTABanner />
    </main>
  );
};

export default Home;
